import { useState } from 'react'
import clsx from 'clsx'
import { Text } from '@/components'
import { MultiselectOption } from '@/app/components/Multiselect'

type Props = {
  option: MultiselectOption
  index: number
  onClick?: (index: number, selected: boolean) => void
}

export default function MultiselectButton(props: Props) {
  const [selected, setSelected] = useState(props.option.selected)

  const onClick = () => {
    setSelected((prev) => {
      props.onClick?.(props.index, !prev)
      return !prev
    })
  }

  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center w-fit rounded-full px-4 py-2.5 cursor-pointer border border-2 border-solid transition',
        {
          'bg-[#EBF0FF] border-[#3768FB] hover:bg-[#EBF0FF]': selected,
          'bg-themed-grey-200 border-transparent hover:bg-gray-300': !selected,
        },
      )}
      onMouseDown={onClick}
    >
      <Text variant="body1" className={clsx({ 'text-[#3768FB]': selected })}>
        {props.option.text}
      </Text>
    </button>
  )
}
